import { useEffect } from "react";

export function useAutoCleanError<T>(value: T, cleanFn: (val: T) => void, delay: number = 500) {
  if(!value) return;

  useEffect(() => {
    const timer = setTimeout(() => {
      cleanFn("" as T)
    }, delay);

    return () => clearTimeout(timer)
  }, [value, cleanFn, delay])
}